import { setup } from "twind";

setup({
  preflight: false,
  darkMode: "class"
});
